<template>
   <div class="basislist">
        <div v-for="(li,index) in list" :key="index" class="listcard" >
            <common-link :item='li' :page="basislist"></common-link>
        </div>
    </div>
</template>
<script>
import commonLink from './commonLink'
export default {
    data() {
      return {
        list:[],
        basislist:'basislist'
      }
    },
    components:{
      commonLink
    },
    props: ['basis'],
    watch:{
      basis:{
        handler(newName, oldName) {
          this.list=newName
        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
 .basislist{
    .listcard{
         position: relative;
         margin-bottom: 0.75rem;
         border-radius: 0.375rem;
         width: 100%;
         height: 9rem;
         overflow: hidden;
        
    }
            
}
</style>





// WEBPACK FOOTER //
// src/components/basislist.vue